export default {
  LOAD_CYCLE_FORM_PAGE_START: 'LoadCycleFormPageStart',
  LOAD_CYCLE_FORM_PAGE_END: 'LoadCycleFormPageEnd',
  SEARCH_CYCLE_FORM_PAGE_STUDY_PROGRAMS_START: 'SearchCycleFormPageStudyProgramsStart',
  SEARCH_CYCLE_FORM_PAGE_STUDY_PROGRAMS_END: 'SearchCycleFormPageStudyProgramsEnd',
  LOAD_CYCLE_CHILDREN_AVAILABLE_STUDY_PROGRAM_START: 'LoadCycleChildrenAvailableStudyProgramStart',
  LOAD_CYCLE_CHILDREN_AVAILABLE_STUDY_PROGRAM_END: 'LoadCycleChildrenAvailableStudyProgramEnd',
  SEARCH_CYCLE_FORM_PAGE_ADMINISTRATORS_START: 'SearchCycleFormPageAdministratorsStart',
  SEARCH_CYCLE_FORM_PAGE_ADMINISTRATORS_END: 'SearchCycleFormPageAdministratorsEnd',
  LOAD_CYCLE_CHILDREN_AVAILABLE_DESIGNATIONS_ADMINISTRATORS_START: 'LoadCycleChildrenAvailableDesignationsAdministratorsStart',
  LOAD_CYCLE_CHILDREN_AVAILABLE_DESIGNATIONS_ADMINISTRATORS_END: 'LoadCycleChildrenAvailableDesignationsAdministratorsEnd'
};